import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Auth/Login.vue';
import Register from '../views/Auth/Register.vue';
import Home from '../views/Home.vue';
import EditProfile from '../views/User/EditProfile.vue';
import ContactUs from '../views/ContactUs.vue';
import Message from '../views/Message.vue';
import StepOne from "../views/Orders/Create/StepOne.vue";
import StepTwo from "../views/Orders/Create/StepTwo.vue";
import StepThree from "../views/Orders/Create/StepThree.vue";
import StepFour from "../views/Orders/Create/StepFour.vue";
import Order from '../views/Order.vue';
import OrderDetails from '../views/OrderDetails.vue';
import store from '@/store';
import { encrypt } from "@/helpers/support.js";

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter: (to, form, next) => {
      if (store.getters['auth/check']) {
        next({
          name: 'home',
        });
      }

      next();
    },
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    beforeEnter: (to, from, next) => {
      if (store.getters['auth/check']) {
        next({
          name: 'home',
        });
      }

      next();
    },
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/check']) {
        next({
          name: 'login',
        });
      }

      next();
    },
  },
  {
    path: '/profile/edit',
    name: 'edit-profile',
    component: EditProfile,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/check']) {
        next({
          name: 'login',
        });
      }

      next();
    },
  },
  {
    path: '/contact-us',
    name: 'contact-us',
    component: ContactUs,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/check']) {
        next({
          name: 'login',
        });
      }

      next();
    },
  },
  {
    path: '/orders/:id/messages',
    name: 'message',
    component: Message,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/check']) {
        next({
          name: 'login',
        });
      }

      next();
    },
  },
  {
    path: '/orders',
    name: 'order',
    component: Order,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/check']) {
        next({
          name: 'login',
        });
      }

      next();
    },
  },
  {
    path: '/orders/:id',
    name: 'order-details',
    component: OrderDetails,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/check']) {
        next({
          name: 'login',
          query: {ref: encrypt(to.params.id.toString())}
        });
      }

      next();
    },
  },
  {
    path: '/:slug/step-one',
    name: 'step-one',
    component: StepOne,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/check']) {
        next({
          name: 'login',
        });
      }

      if (store.getters['service/service'] === null) {
        next({
          name: 'home',
        });
      }

      next();
    },
  },
  {
    path: '/:slug/step-two',
    name: 'step-two',
    component: StepTwo,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/check']) {
        next({
          name: 'login',
        });
      }

      if (store.getters['service/service'] === null) {
        next({
          name: 'home',
        });
      }

      next();
    },
  },
  {
    path: '/:slug/step-three',
    name: 'step-three',
    component: StepThree,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/check']) {
        next({
          name: 'login',
        });
      }

      if (store.getters['service/service'] === null) {
        next({
          name: 'home',
        });
      }

      next();
    },
  },
  {
    path: '/:slug/step-four',
    name: 'step-four',
    component: StepFour,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/check']) {
        next({
          name: 'login',
        });
      }

      if (store.getters['service/service'] === null) {
        next({
          name: 'home',
        });
      }

      next();
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

export default router;
